// RegisterForm.jsx
import React, { useState } from "react";
import { Box, TextField, Button, Alert, Typography, Link as MuiLink } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { PersonAdd } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";

function RegisterForm() {
	const [username, setUsername] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	const [loading, setLoading] = useState(false);

	const { register } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!username.trim() || !email.trim() || !password || !confirmPassword) {
			setError("Please fill in all fields");
			return;
		}

		if (password !== confirmPassword) {
			setError("Passwords do not match");
			return;
		}

		setLoading(true);
		setError(null);

		try {
			const res = await register(username, email, password);
			setSuccess(res.message || "Registration successful. Please wait for admin approval.");
			// navigate("/"); // Do not redirect
		} catch (err) {
			setError(err.response?.data?.message || "Registration failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box component="form" onSubmit={handleSubmit}>
			{success && (
				<Alert severity="success" sx={{ mb: 3 }}>
					{success}
				</Alert>
			)}
			{error && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{error}
				</Alert>
			)}

			<TextField
				label="Username"
				variant="outlined"
				fullWidth
				margin="normal"
				value={username}
				onChange={(e) => setUsername(e.target.value)}
				required
			/>

			<TextField
				label="Email"
				type="email"
				variant="outlined"
				fullWidth
				margin="normal"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				required
			/>

			<TextField
				label="Password"
				type="password"
				variant="outlined"
				fullWidth
				margin="normal"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				required
			/>

			<TextField
				label="Confirm Password"
				type="password"
				variant="outlined"
				fullWidth
				margin="normal"
				value={confirmPassword}
				onChange={(e) => setConfirmPassword(e.target.value)}
				error={confirmPassword && password !== confirmPassword}
				helperText={confirmPassword && password !== confirmPassword ? "Passwords don't match" : ""}
				required
			/>

			<Button type="submit" variant="contained" fullWidth size="large" disabled={loading} startIcon={<PersonAdd />} sx={{ mt: 3, mb: 2 }}>
				{loading ? "Registering..." : "Register"}
			</Button>

			<Box sx={{ textAlign: "center", mt: 2 }}>
				<Typography variant="body2">
					Already have an account?{" "}
					<MuiLink component={Link} to="/login">
						Sign in
					</MuiLink>
				</Typography>
			</Box>
		</Box>
	);
}

export default RegisterForm;
